// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetFormValidationState = () => false;

const updateFormValidationState = (state, action) => action.isFormValid;

export default (state = getDefaultState().isFormValid, action) => {

    const actionTypes = {
        [actions.RESET_PIP_CODE]: resetFormValidationState,
        [actions.UPDATE_FORM_VALIDATION_STATE]: updateFormValidationState
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/form-validation.js